import { http } from '../../../common/http/client';

interface InvestorContactData {
  name: string;
  email: string;
  phone: string;
  income: number | null;
  assets: number | null;
  qualification: number[] | null;
  interest_type: number | null;
  requested_sales_info: number | null;
  privacy_confirmed: boolean;
}

interface CreateParams {
  investor_contact: InvestorContactData;
}

export default class InvestorContactClient {
  create(params: CreateParams): Promise<void> {
    return http.post<void>('/api/v1/investor_contacts', { json: params });
  }
}
